import * as firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/analytics';

import {FIREBASE_CONFIG} from "@/api_keys"

const firebaseApp = firebase.initializeApp(FIREBASE_CONFIG);

export const auth = firebaseApp.auth();
export const db = firebaseApp.firestore();
export const analytics = firebaseApp.analytics();

// export firebase types
export const { TimeStamp, GeoPoint, FieldValue } = firebase.firestore
